
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import localityService from '@/apps/shared/services/locality-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import saveEmissionService from '../../../shared/services/saveEmission-service';
    import getSelectedProducerService from '../../../shared/services/selectedProducer-service';
    export default Vue.extend({
        el: '#step1',
        name: 'TabOne',
        data() {
            return {
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                telephone: '',
                streetName: null,
                nacimiento: null,
                messageErrorAge: null,
                age: '0',
                stringDate: '',
                piso: null,
                numDom: null,
                numDept: null,
                areaCode: '',
                email: '',
                numDoc: null,
                selectedLocality: null,
                cityName: null,
                cityId2: null,
                StreetriskAddress: null,
                numRiskAddress: null,
                riskAddress: null,
                localityId: null,
                zipCode: null,
                Procesoautomatico: false,
                documentTypeList: [{ id: "", text: "" }],
                MaximDigitSuperatedDni: false,
                isPersonExist: false,
                isNotSelectedDocumentType: true,
                docTypeSelected: null,
                maxSelections: 2,
                activeForm: false,
                minimumInputLength: 4,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                accept: true,
                DataPlan: null,
                planDescription: null,
                primerCuota: null,
                coberturasAmparo: [],
                gender: null,
                officeId: null,
                city: null,
                address: null,
                selectedIvaCondition: null,
                province: null,
                genderId: null,
                firstName: "",
                lastName: "",
                activeFormPersonNoExist: false,
                hasLocality: false,
                localityIsSelected: true,
                disable: true,
                validatePhone: false,
                messageErrorAreaCode: null,
                messageErrorPhone: null,
                messageError: null,
                messageErrorDigits: null,
                validDigits: null,
                numDocChange: null,
                numDocExisting: null,
                clientCode: "0",
                originId: 4,
                multiplePeopleWithSameIdentifier: [],
                clientId: null,
                mapURL: "",
                mapVisible: false,
                showMapButton: true,
                referente: null,
            }
        },
        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true
                let message = ""
                if (this.docTypeSelected.id == 'D' && val.length != 7 && val.length != 8) {
                    this.disable = true;
                    if (val.length > 0) {
                        valid = false
                        message = "La cantidad de dígitos es incorrecto"
                    }
                    else {
                        valid = false
                        message = "Este campo es obligatorio."
                    }
                } else if (this.docTypeSelected.id == 'D' && (val.length == 7 || val.length == 8)) {
                    if (this.numDocExisting != val) {
                        this.numDocChange = true;
                        this.numDocExisting = val;
                    }

                    this.disable = false;
                }
                else {
                    this.disable = false;
                }
                return {
                    valid,
                    message
                }
            };

            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },
        methods: {
            onSelectedClient(id) {
                this.clientId = id;
                this.acceptSelectMultiplePeopleModal();
            },

            openSelectMultiplePeopleModal: function (peopleList) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                // Inicializar el array multiplePeopleWithSameIdentifier
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => {
                    let newPerson = {
                        id: idCounter++,
                        birthday: person.birthday,
                        firstName: person.firstName,
                        lastName: person.lastName,
                        email: person.email,
                        selectedIvaCondition: person.ivaConditionFiscalId,
                        areaCode: person.phoneAreaCode,
                        telephone: person.phoneNumber,
                        hasLocality: person.hasLocality,
                        address: null,
                        document: null
                    };
                    if (person.address != null && person.address != undefined) {
                        newPerson.address = {
                            cityId: person.address.cityId,
                            streetNumber: person.address.streetNumber,
                            streetName: person.address.streetName,
                            zipCode: person.address.zipCode,
                            floor: person.address.floor,
                            department: person.address.department
                        };
                    };
                    if (person.document != null && person.document != undefined) {
                        newPerson.document = person.document;
                    };
                    return newPerson;
                });
                this.$refs.selectMultiplePeopleModal.open();
            },

            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.clientId = null;
            },

            closeSelectMultiplePeopleModal: function () {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                this.$refs.selectMultiplePeopleModal.close();
            },

            acceptSelectMultiplePeopleModal() {
                let selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => this.clientId == item.id);
                this.setPersonToCover(selectedPerson);
                searchPersonService.SetPerson(selectedPerson.lastName, selectedPerson.firstName)
                    .then(response => {
                        setTimeout(() => {
                            this.closeSelectMultiplePeopleModal();
                        }, 300);
                    })
                    .catch(error => {
                        this.getPersonByDocumentAndType();
                    });
            },

            setPersonToCover(personToCover) {
                let dataClientTabOne = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                this.activeFormPersonNoExist = false;
                this.isPersonExist = true;
                this.activeForm = true;
                this.nacimiento = personToCover.birthday;
                this.firstName = personToCover.firstName;
                this.lastName = personToCover.lastName;
                this.email = dataClientTabOne.email;
                this.areaCode = dataClientTabOne.areaCode;
                this.telephone = dataClientTabOne.telephone;
                this.hasLocality = personToCover.hasLocality;
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.email,
                    'product': 'hogarPremium',
                    'event': 'cotizador-hogar-premium-dni',
                    'referente': this.referente
                });
            },

            searchPersonData() {
                this.streetName = null;
                this.piso = null;
                this.numDom = null;
                this.numDept = null;
                this.selectedLocality = null;
                this.getPersonByDocumentAndType();
            },

            getTelephoneValidation() {
                return new Promise<any>(async (resolve) => {
                    await this.validPhone();
                    NF.Validation.Field.removeField("#form1", "areaCode");
                    NF.Validation.Field.removeField("#form1", "telephone");

                    NF.Validation.Field.addField("#form1", "areaCode", {
                        validators: {
                            stringLength: {
                                message: this.messageErrorAreaCode,
                            }
                        }
                    });
                    NF.Validation.Field.validate("#form1", "areaCode");
                    NF.Validation.Field.addField("#form1", "telephone", {
                        validators: {
                            stringLength: {
                                message: this.messageErrorPhone,
                            }
                        }
                    });
                    NF.Validation.Field.validate("#form1", "telephone");
                })
            },

            getFilePath() {
                this.Bus.$emit('redirectPlan');
            },

            validate: function (config, direction) {
                if (direction == "backward") {
                    this.getFilePath();
                    return true
                }
                if (!this.numDocChange) {
                    var formIsValid = NF.Validation.Form.validate('#form1');
                    if (!formIsValid) {
                        return formIsValid;
                    }
                    if (!this.hasLocality && config.viewModel.selectedLocality == null) {
                        this.localityIsSelected = false;
                        return false
                    }
                    if (direction != "backward") {
                        var timeStart = new Date();
                        sessionStorage.setItem("TimeStart", JSON.stringify(timeStart));
                        sessionStorage.removeItem("stepOneData");
                        var birthDay = new Date(config.viewModel.nacimiento.toString());
                        var birthDayFormated = (birthDay.getFullYear() + '/' + (birthDay.getMonth() + 1 + '/' + birthDay.getDate()));
                        sessionStorage.setItem("stepOneData", JSON.stringify({
                            documentType: config.viewModel.docTypeSelected,
                            documentNumber: config.viewModel.numDoc,
                            birthDay: birthDayFormated,
                            areaCode: config.viewModel.areaCode,
                            telephone: config.viewModel.telephone,
                            email: config.viewModel.email,
                            firstName: config.viewModel.firstName,
                            lastName: config.viewModel.lastName,
                            zipCode: (!this.isPersonExist || !this.hasLocality) ? config.viewModel.selectedLocality.zipCode : 0,
                            localityId: (!this.isPersonExist || !this.hasLocality) ? config.viewModel.selectedLocality.id : null,
                            streetName: config.viewModel.streetName,
                            piso: config.viewModel.piso,
                            numDom: config.viewModel.numDom,
                            numDept: config.viewModel.numDept,
                            countryCode: null,
                        }));

                        this.SaveEmission();
                    } else {
                        return formIsValid;
                    }
                } else {
                    this.searchPersonData();
                    return false;
                }
            },

            SaveEmission: function () {
                return new Promise<any>(async (resolve) => {
                    this.stepOneData = JSON.parse(sessionStorage.getItem("stepOneData"));
                    this.twoData = JSON.parse(sessionStorage.getItem("TabTwoData"));
                    //Llama al servicio que trae el producerId y el OrganizerId
                    await getSelectedProducerService.GetSelectedProducer(
                        this.clientCode,
                        this.stepOneData.localityId,
                        0,
                        this.originId,
                        this.stepOneData.zipCode).then(async response => {
                            var a = response;
                            //Se consume el Servicio de SaveEmission con los datos correspondientes
                            var birthDay = this.stepOneData.birthDay;
                            if (birthDay == null || birthDay == undefined) {
                                birthDay = "01/01/1900"
                            }
                            var dateFormat = new Date(birthDay);
                            var JsonEmissionData = JSON.stringify({
                                birthday: dateFormat,
                                cityCode: this.stepOneData.localityId != null ? parseInt(this.stepOneData.localityId) : 0,
                                clientAddress: {
                                    department: this.stepOneData.numDept == null ? "" : this.stepOneData.numDept.toString(),
                                    floor: parseInt(this.stepOneData.piso == null ? 0 : this.stepOneData.piso),
                                    streetName: this.stepOneData.streetName == null ? "" : this.stepOneData.streetName.toString(),
                                    streetNumber: this.stepOneData.numDom == null ? "" : this.stepOneData.numDom.toString(),
                                },
                                clientFirstName: (this.stepOneData.firstName != null && this.stepOneData.firstName != "") ? this.stepOneData.firstName.toString() : "",
                                clientLastName: (this.stepOneData.lastName != null && this.stepOneData.lastName != "") ? this.stepOneData.lastName.toString() : " ",
                                documentNumber: parseInt(this.stepOneData.documentNumber),
                                documentType: this.stepOneData.documentType.id.trim(),
                                email: this.stepOneData.email != null ? this.stepOneData.email.toString() : null,
                                phones: [{
                                    areaCode: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.areaCode),
                                    countryCode: this.stepOneData.countryCode == null ? null : parseInt(this.stepOneData.telephone[0].countryCode),
                                    order: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.telephone[0].order),
                                    phoneNumber: this.stepOneData.telephone == null ? "" : this.stepOneData.telephone.toString(),
                                    phoneType: this.stepOneData.telephone == null ? null : parseInt(this.stepOneData.telephone[0].phoneType)
                                }],
                                zipCode: this.stepOneData.zipCode,
                                ElectronicCode: 0,
                                CategoryConstructionCode: this.twoData.buildTypeCode,
                                RoofType: 5,
                                SideCloseTypeCode: 0,
                                SeismicZoneCode: 0,
                                ReplacementHouse: true,
                                BuildingAntique: 0,
                                QuantityFloor: 0,
                                riskAddress: {
                                    cityCode: parseInt(this.twoData.selectedLocality.id),
                                    streetName: this.StreetriskAddress + " " + this.numRiskAddress.toString(),
                                    streetNumber: this.numRiskAddress.toString(),
                                    zipCode: parseInt(this.twoData.selectedLocality.zipCode),
                                    cardinalPoint: null,
                                    kilometers: null
                                }

                            })
                            saveEmissionService.FamilyCombinedPremiumSaveEmission(JsonEmissionData).then(response => {
                                if (response.validationResult.errorMessage = "Los datos para la emisión se guardaron correctamente") {
                                    resolve(true)
                                    NF.UI.Page.block();
                                    this.Bus.$emit('redirectSummary');
                                }
                            });
                        });
                })
            },

            createOrEditLead: function () {
                CRMCotizadorWebService.CreateOrEditLead(null, this.email, location.href, this.areaCode, this.telephone, 936, false, "5", null, null, null);
            },

            validPhone: function () {
                if (this.telephone == "" && this.areaCode == "") {
                    this.validDigits = true;
                }
                return new Promise<any>(async (resolve) => {
                    await phoneValidateService.validatePhone(this.areaCode, this.telephone).then(async o => {
                        if (o.areaCodeSuccess == false) {
                            this.messageErrorAreaCode = o.message
                        }
                        if (o.phoneNumberSuccess == false) {
                            this.messageErrorPhone = o.message
                        }
                        if (o.validCountDigit != null) {
                            if (o.validCountDigit) {
                                this.messageErrorDigits = "";
                            }
                            else {
                                this.messageErrorDigits = o.message
                            }
                        }
                        else {
                            this.messageErrorDigits = "";
                        }
                        this.validatePhone = o.validCountDigit;
                        resolve(true);
                    });
                })
            },

            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element =>
                            ({ ...element, id: element["id"], text: element["name"] }))
                        this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                })
            },

            getPersonByDocumentAndType: function () {
           
                this.numDocChange = false;
                this.activeFormPersonNoExist = false;
                this.hasLocality = false;
                var dataClientTabOne = this.DataPlan = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                if (this.numDoc != "") {
                    this.Bus.$emit('enableFinalButton');
                    var Dni = this.numDoc == null ? 0 : this.numDoc;
                    var DocTypeSeleccionado = this.docTypeSelected.name.trim();
                    searchPersonService.GetSearchPersonData(this.numDoc, this.docTypeSelected.id)
                        .then(response => {
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }
                            let result = response.searchPersonResult[0];
                            if (result != undefined && (result && result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.activeFormPersonNoExist = false;
                                this.isPersonExist = true;
                                this.activeForm = true;
                                this.nacimiento = result.birthday;
                                this.firstName = result.firstName;
                                this.lastName = result.lastName;
                                this.email = dataClientTabOne.email;
                                this.areaCode = dataClientTabOne.areaCode;
                                this.telephone = dataClientTabOne.telephone;
                                this.hasLocality = result.hasLocality;
                                window.globalThis.dataLayer.push({
                                    'pas': null,
                                    'email': this.email,
                                    'product': 'hogarPremium',
                                    'event': 'cotizador-hogar-premium-dni',
                                    'referente': this.referente
                                });
                            }
                            else {
                                this.activeForm = true;
                                this.isPersonExist = false;
                                this.firstName = dataClientTabOne.name;
                                this.email = dataClientTabOne.email;
                                this.areaCode = dataClientTabOne.areaCode;
                                this.telephone = dataClientTabOne.telephone;
                                this.age = "";
                                this.nacimiento = null;
                                this.lastName = dataClientTabOne.lastName;
                                this.activeFormPersonNoExist = true;
                                this.selectedLocality = null;
                                window.globalThis.dataLayer.push({
                                    'pas': null,
                                    'email': this.email,
                                    'product': 'hogarPremium',
                                    'event': 'errorUsuario',
                                    'paso': 'cotizador-hogar-premium-dni',
                                    'referente': this.referente
                                });
                            }
                            if (Dni.toString().length > 0 && Dni.toString().length < 9) {
                                this.MaximDigitSuperatedDni = false;
                            }
                            else if (DocTypeSeleccionado == "DNI") {
                                this.MaximDigitSuperatedDni = true;
                                this.firstName = "";
                                this.lastName = "";
                                this.nacimiento = null;
                                this.isPersonExist = true;
                                this.isNotSelectedDocumentType = false
                                this.age = "";
                            }
                            else {
                                this.MaximDigitSuperatedDni = true;
                            }
                        }).then(() => NF.UI.Page.unblock());
                }
                else {
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },

            CleanPersonDataForm: function () {
                if (this.numDoc == "") {
                    NF.UI.Page.blockCustom({ message: 'Limpiando datos..' });
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },

            isSelectedDocumentType: function () {
                this.isNotSelectedDocumentType = false
                this.docTypeSelected != null ? this.docTypeSelected.name.trim() != "CUIT" ? (this.isPerson = true, this.isJuridico = false) : (this.isJuridico = true, this.isPerson = false) : null
                this.nacimiento = null;
                this.numDoc = ""
                this.piso = "";
                this.numDept = "";
                this.numDom = "";
                this.streetName = null;
                this.isPersonExist = true;
                this.hasLocality = false;
            },

            isSelectedLocality: function () {
                this.locality = this.selectedLocality.text;
                if (this.zipCode == undefined || this.zipCode == null) {
                    this.zipCode = this.selectedLocality.zipCode;
                }
                this.provinceName = this.selectedLocality.provinceName;
                this.cityName = this.selectedLocality.name;
                // la persona existe pero necesito modificar el id de la localidad
                if (this.isPersonExist == false) {
                    this.localityId = this.selectedLocality.id;
                }
                else if (this.Procesoautomatico == false) {
                    //Si existe la persona , Pregunto si pase por el proceso automatico de datos al cargar un dni
                    this.localityId = this.selectedLocality.id;
                    this.zipCode = this.selectedLocality.zipCode;
                }
                else {
                    if (this.cityId2 != null) {
                        this.localityId = this.cityId2;
                    }
                    //si el usuario existe pero no trae la localidad tomarla del selector
                    else {
                        this.localityId = this.selectedLocality.id
                    }
                    this.Procesoautomatico = false;
                }
            },

            calcularEdad: function () {
                this.messageErrorAge = ""
                if (this.nacimiento != null && this.nacimiento != "") {
                    var today = new Date();
                    if (this.nacimiento.toString().length > 11) {
                        var birthDate = new Date(this.nacimiento);
                        var age = today.getFullYear() - birthDate.getFullYear();
                        var m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                        }
                        this.age = age;
                        if (this.age < 18) {
                            this.messageErrorAge = "La persona debera ser mayor de 18 años"
                        }
                        else {
                            this.messageErrorAge = ""
                        }
                    }
                    else {
                        var dateFormated = this.nacimiento.split('/')[1] + "/" + this.nacimiento.split('/')[0] + "/" + this.nacimiento.split('/')[2];
                        var birthDate = new Date(dateFormated);
                        var age = today.getFullYear() - birthDate.getFullYear();
                        var m = today.getMonth() - birthDate.getMonth();
                        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                        }
                        this.age = age;
                        if (this.age < 18) {
                            this.messageErrorAge = "La persona deberá ser mayor de 18 años"
                        }
                        else {
                            this.messageErrorAge = ""
                        }
                    }
                }
                else {
                    this.age = 0;
                }
            },
            addMapURL() {
                const tabTwoSelectedLocality = JSON.parse(sessionStorage.getItem("TabTwoData"))?.selectedLocality;

                const mapRiskAddress = this.riskAddress ? this.riskAddress : this.StreetriskAddress + ' ' + this.numRiskAddress;

                const encodedMapRiskAddress = encodeURIComponent(mapRiskAddress).replace(/\%20/g, '+');

                const location = encodeURIComponent(tabTwoSelectedLocality.name);
                const province = encodeURIComponent(tabTwoSelectedLocality.provinceName);
                const country = encodeURIComponent("Argentina");

                if (!mapRiskAddress.trim()) {
                    this.mapURL = "https://maps.google.com/maps?q=" + location + "%2C+" + province + "%2C+" + country + "&t=&z=16&ie=UTF8&iwloc=&output=embed";
                } else {
                    this.mapURL = "https://maps.google.com/maps?q=" + encodedMapRiskAddress + "%2C+" + location + "%2C+" + province + "%2C+" + country + "&t=&z=16&ie=UTF8&iwloc=&output=embed";
                }

                if (this.mapVisible) {
                    this.updateMapView();
                }
            },
            showMap() {
                this.mapVisible = true;
                this.showMapButton = false;
                this.addMapURL();
                this.updateMapView();
            },
            hideMap() {
                this.mapVisible = false;
                this.showMapButton = true;
            },
            changeMapVisibility() {
                this.mapVisible = !this.mapVisible; 

                if (this.mapVisible) {
                    this.addMapURL(); 
                }

                this.showMapButton = !this.mapVisible;
            },
            updateMapView() {
                if (this.mapVisible) {
                    this.mapURL = this.mapURL;
                }
            },
            getInitData() {
                NF.UI.Page.block();
                this.Bus.$on('get-step-one-data', () => this.Bus.$emit('step-one-data', this.$data))
                this.getDocumentType();
            }
        },
        watch: {
            nacimiento(newVal) {
                if (newVal != null || newVal != "") {
                    this.calcularEdad();
                }
            },
            selectedLocality(newVal) {
                if (this.selectedLocality != null) {
                    this.localityIsSelected = true;
                }
            },
            areaCode(newVal) {
                if (newVal != null && newVal != "") {
                    this.getTelephoneValidation();
                }
            },
            telephone(newVal) {
                if (newVal != null && newVal != "") {
                    this.getTelephoneValidation();
                }
            },
            telephoneCompleteDigit() {
                this.getTelephoneValidation();
            },
            numDoc(newVal) {
                if (newVal == "") {
                    this.Bus.$emit('disableFinalButton');
                    this.disable = true;
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },
            StreetriskAddress(newVal) {
                if (newVal) {
                    this.addMapURL();
                    if (this.mapVisible) {
                        this.updateMapView();
                    }
                }
            },
            numRiskAddress(newVal) {
                if (newVal) {
                    this.addMapURL();
                    if (this.mapVisible) {
                        this.updateMapView(); // Solo actualiza el mapa si está visible
                    }
                }
            },
            mapVisible(newVal) {
                if (newVal) {
                    this.updateMapView();
                }
            }
        },
        mounted() {
            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

            this.getInitData();
        }
    });
